'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var React = require('react');
var utils = require('./utils.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var _excluded = ["min", "max", "value", "isIndeterminate"],
  _excluded2 = ["value", "min", "max", "children", "borderRadius", "isIndeterminate", "aria-label", "aria-labelledby"],
  _excluded3 = ["trackFilledColor"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * ProgressFilledTrack
 *
 * The progress component that visually indicates the current level of the progress bar.
 * It applies `background-color` and changes its width.
 *
 * @see Docs https://chakra-ui.com/progress
 */
var ProgressFilledTrack = function ProgressFilledTrack(props) {
  var min = props.min,
    max = props.max,
    value = props.value,
    isIndeterminate = props.isIndeterminate,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var progress = utils.getProgressProps({
    value: value,
    min: min,
    max: max,
    isIndeterminate: isIndeterminate
  });
  var styles = react.useStyles();
  var trackStyles = _objectSpread({
    height: '100%'
  }, styles.filledTrack);
  return /*#__PURE__*/React__namespace.createElement(react.chakra.div, _extends__default["default"]({
    style: _objectSpread({
      width: "".concat(progress.percent, "%")
    }, rest.style)
  }, progress.bind, rest, {
    __css: trackStyles
  }));
};
/**
 * Progress bar
 *
 * Progress is used to display the progress status for a task that takes a long
 * time or consists of several steps.
 *
 * It includes accessible attributes to help assistive technologies understand
 * and speak the progress values.
 *
 * @see Docs https://chakra-ui.com/progress
 */
var ProgressBar = function ProgressBar(props) {
  var _styles$track;
  var _omitThemingProps = react.omitThemingProps(props),
    value = _omitThemingProps.value,
    _omitThemingProps$min = _omitThemingProps.min,
    min = _omitThemingProps$min === void 0 ? 0 : _omitThemingProps$min,
    _omitThemingProps$max = _omitThemingProps.max,
    max = _omitThemingProps$max === void 0 ? 100 : _omitThemingProps$max,
    children = _omitThemingProps.children,
    propBorderRadius = _omitThemingProps.borderRadius,
    isIndeterminate = _omitThemingProps.isIndeterminate,
    ariaLabel = _omitThemingProps['aria-label'],
    ariaLabelledBy = _omitThemingProps['aria-labelledby'],
    rest = _objectWithoutProperties__default["default"](_omitThemingProps, _excluded2);

  // Chakra overwrite: Filter custom `trackFilledColor` to prevent it from passing to DOM.
  rest.trackFilledColor;
  var chakraDivProps = _objectWithoutProperties__default["default"](rest, _excluded3);
  var styles = react.useMultiStyleConfig('ProgressBar', props);
  var borderRadius = propBorderRadius !== null && propBorderRadius !== void 0 ? propBorderRadius : (_styles$track = styles.track) === null || _styles$track === void 0 ? void 0 : _styles$track.borderRadius;

  /**
   * Generate styles for stripe and stripe animation
   */
  var css = _objectSpread({}, isIndeterminate && {
    position: 'absolute',
    willChange: 'left',
    minWidth: '50%',
    animation: "".concat(utils.animation, " 1s ease infinite normal none running")
  });
  var trackStyles = _objectSpread({
    overflow: 'hidden',
    position: 'relative'
  }, styles.track);
  return /*#__PURE__*/React__namespace.createElement(react.chakra.div, _extends__default["default"]({
    borderRadius: borderRadius,
    __css: trackStyles
  }, chakraDivProps), /*#__PURE__*/React__namespace.createElement(react.StylesProvider, {
    value: styles
  }, /*#__PURE__*/React__namespace.createElement(ProgressFilledTrack, {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    min: min,
    max: max,
    value: value,
    isIndeterminate: isIndeterminate,
    css: css,
    borderRadius: borderRadius
  }), children));
};
ProgressBar.displayName = 'ProgressBar';
exports.ProgressBar = ProgressBar;